export const UserTypeStandard = 'standard'
export const UserTypeTeacher = 'teacher'
export const UserTypeStudent = 'student'
export const UserTypeJudge = 'judge'
export const UserTypeMentor = 'mentor'
export const UserTypePoster = 'poster'
export const UserTypeBooth = 'booth'
export const UserTypeStemExpo = 'stemExpo'
export const UserTypeJacAdmin = 'JACAdmin'

const UserTypes = [UserTypeStandard, UserTypeTeacher, UserTypeStudent, UserTypeJudge, UserTypeMentor, UserTypeJacAdmin, UserTypePoster, UserTypeBooth, UserTypeStemExpo]

export default {
  data: function () {
    return {
      UserTypeStandard,
      UserTypeTeacher,
      UserTypeStudent,
      UserTypeJudge,
      UserTypes,
      UserTypeMentor,
      UserTypeJacAdmin,
      UserTypePoster,
      UserTypeBooth,
      UserTypeStemExpo
    }
  }
}
